import { UserMemberProfileDTO, UserMemberSignupDTO } from "@gymflow/types";
import { mutationOptions, QueryKey, queryOptions } from "@tanstack/react-query";

import { api } from "../../api";

const keys = {
  all: () => ["hostedApiMember"] as QueryKey,
  emailExists: (email: string) =>
    [...keys.all(), "emailExists", email] as QueryKey,
};

export const hostedApiMember = {
  keys,
  queries: {
    emailExists: (email: string) =>
      queryOptions({
        queryKey: keys.emailExists(email),
        queryFn: async () => {
          return (
            await api.get<boolean>(`/hosted/catalog/user/email/check`, {
              params: { q: email.toLowerCase() },
            })
          ).data;
        },
      }),
  },
  infiniteQueries: {},
  mutations: {
    signUp: () =>
      mutationOptions({
        mutationFn: async (data: UserMemberSignupDTO) => {
          return (
            await api.post<UserMemberProfileDTO>(
              "/hosted/user-member-signup",
              data,
            )
          ).data;
        },
      }),
  },
};
